import { RootState } from '@/app/store.ts';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

// Define a type for the slice state
export interface ApplicationContextState {
  theme: string; // "ScssConsole" | "ScssPartner";
  isLoading: boolean;
  isLogged: boolean;
  invalidCredentials: boolean;
}

// Define the initial state using that type
const INITIAL_STATE: ApplicationContextState = {
  theme: '',
  isLoading: false,
  isLogged: false,
  invalidCredentials: false,
};

export const ApplicationSlice = createSlice({
  name: 'context',
  initialState: INITIAL_STATE,
  reducers: {
    setTheme: (state, action: PayloadAction<string>) => {
      state.theme = action.payload;
    },
    setAppIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setIsLogged: (state, action: PayloadAction<boolean>) => {
      state.isLogged = action.payload;
    },
    setInvalidCredentials: (state, action: PayloadAction<boolean>) => {
      state.invalidCredentials = action.payload;
    },
  },
});

export const { setTheme, setIsLogged, setInvalidCredentials, setAppIsLoading } =
  ApplicationSlice.actions;

/**
 * Slice for the app
 *
 * @param state the rootstate
 * @returns     the state of the application
 */
export const getApplicationState = (state: RootState) =>
  state.applicationContext;
